module.exports = __webpack_public_path__ + "img/bg_black_factory.1b9b2075.jpg";